const filterMembers = (members, searchValue) => {
  const queries = searchValue.toLowerCase().split(' ');
  if (!searchValue) return members;

  return members.filter((m) =>
    queries.some((q) => {
      if (!q) return false;
      const name = (m.first_name || '').toLowerCase();
      const lastName = (m.last_name || '').toLowerCase();
      const email = (m.email || '').toLowerCase();
      const displayName = (m.display_name || '').toLowerCase();
      return (
        name.includes(q) || lastName.includes(q) || email.includes(q) || displayName.includes(q)
      );
    })
  );
};

export default filterMembers;
